export default {
  ADD_DEVICE: "ADD_DEVICE",
  GET_KPI: "GET_KPI",
  SAVE_KPI: "SAVE_KPI",
};
